import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { profile } from '../data/profile';
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="top" className="relative overflow-hidden border-b border-hairline" data-id="element-73" data-mp="9luxogngtxr3">
      <div className="grid-lines pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" data-id="element-74" data-mp="4mi3tby6fqf0" />
      <div className="pointer-events-none absolute inset-x-0 bottom-0 h-40 bg-void" style={{
      maskImage: 'linear-gradient(to bottom, transparent, black)'
    }} aria-hidden="true" data-id="element-75" data-mp="129qs1epkbdkp" />

      <div className="relative mx-auto max-w-6xl px-6 pb-24 pt-40 lg:pb-32 lg:pt-48" data-id="element-76" data-mp="sa9nj0m1r5qb">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="flex flex-wrap items-center gap-x-3 gap-y-2 font-mono text-xs text-ink-mid" data-id="element-77" data-mp="nczrv382dxu1">
          <span className="flex items-center gap-1.5 text-ink-hi" data-id="element-78" data-mp="384s4img5wh20">
            <span className="h-1.5 w-1.5 rounded-full bg-teal" aria-hidden="true" data-id="element-79" data-mp="3j923fiwkdgsw" />
            {profile.name}
          </span>
          <span className="text-hairline" aria-hidden="true" data-id="element-80" data-mp="3o59e1ozwngh6">
            /
          </span>
          <span data-id="element-81" data-mp="39cfkiznsszti">{profile.role}</span>
          <span className="text-hairline" aria-hidden="true" data-id="element-82" data-mp="3e8wjkowjcyld">
            /
          </span>
          <span className="flex items-center gap-1.5" data-id="element-83" data-mp="30iawsp3yo4i7">
            <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-84" data-mp="30gq65akrp5pm" />
            {profile.location}
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease
      }} className="mt-7 max-w-4xl font-mono text-5xl font-bold leading-[1.03] tracking-tight text-ink-hi sm:text-6xl lg:text-7xl" data-id="element-85" data-mp="2qjv4wjx40r7n">
          Ingeniería
          <br data-id="element-86" data-mp="2ll0fgz4n04ek" />
          <span className="text-teal" data-id="element-87" data-mp="2ljgyt7f2jrc9">transparente</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease
      }} className="mt-8 grid gap-10 lg:grid-cols-[minmax(0,1fr)_260px] lg:items-end" data-id="element-88" data-mp="s2b9g2qj4r79">
          <p className="max-w-2xl text-lg leading-relaxed text-ink-mid" data-id="element-89" data-mp="i9vqb23hxwks">{profile.intro}</p>

          <dl className="flex gap-8 lg:justify-end" data-id="element-90" data-mp="db2dzczy4bm7">
            <div data-id="element-91" data-mp="1azul7e4dgnxd">
              <dt className="font-mono text-[11px] uppercase tracking-widest text-ink-mid" data-id="element-92" data-mp="1b0drtyoknpw3">
                Abierto desde
              </dt>
              <dd className="mt-1 font-mono text-2xl font-bold text-ink-hi" data-id="element-93" data-mp="112px38qyuidx">jun 2026</dd>
            </div>
            <div data-id="element-94" data-mp="x14ldqq64a5b">
              <dt className="font-mono text-[11px] uppercase tracking-widest text-ink-mid" data-id="element-95" data-mp="x1ny8t0yo8ch">
                Licencia
              </dt>
              <dd className="mt-1 font-mono text-2xl font-bold text-teal" data-id="element-96" data-mp="3lui9cqv5izld">GPL-3.0</dd>
            </div>
          </dl>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.15,
        ease
      }} className="mt-12 flex flex-wrap items-center gap-3" data-id="element-97" data-mp="1x9b5n20k33d3">
          <a href="#proyectos" className="group flex items-center gap-2 rounded-full bg-teal px-6 py-3 font-mono text-sm font-medium text-void transition-colors duration-150 ease-out hover:bg-ink-hi focus:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-void" data-id="element-98" data-mp="268y5vkhju34k">
            Explorar proyectos
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-99" data-mp="2p08we0jd4dvx" />
          </a>
          <a href="#filosofia" className="rounded-full border border-magenta-dim px-6 py-3 font-mono text-sm text-magenta transition-colors duration-150 ease-out hover:border-magenta hover:bg-magenta/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-magenta" data-id="element-100" data-mp="umzkk23cggai">
            Cómo trabajo
          </a>
        </motion.div>

        <motion.ul initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.3,
        delay: 0.2,
        ease
      }} className="mt-16 flex flex-wrap gap-x-6 gap-y-2 border-t border-hairline pt-6 font-mono text-xs uppercase tracking-widest text-ink-mid" data-id="element-101" data-mp="3vk1hruoixuvn">
          {profile.disciplines.map(d => <li key={d} data-id="element-102" data-mp="3cs8tueobazus">{d}</li>)}
        </motion.ul>
      </div>
    </section>;
}